export function canManageTenantSettings(
  user_type,
  permissions = [],
  roles = [],
) {
  if (
    Array.isArray(permissions) &&
    permissions.includes("tenant.settings.update")
  ) {
    return true;
  }

  if (Array.isArray(roles) && roles.includes("admin")) {
    return true;
  }

  return parseInt(user_type, 10) === 3;
}
